import { render } from "./CancelSubs.vue?vue&type=template&id=40ebb4fd"
import script from "./CancelSubs.vue?vue&type=script&lang=js"
export * from "./CancelSubs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__